export default "/images/vendor/@coreui/icons/svg/flag/cif-af.svg?07254004478d06fd2206e1211e902585";